import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { SubjectGradingStandards } from "./routes";

export default store => ({
  path: "standards",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-standards" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [SubjectGradingStandards(store)],
});
